<template>
  <div>
    <h1><router-link :to="{ name: 'admin-design-survey' }">Design</router-link> - Add Page</h1>
    <vue-form-generator
      :schema="buildSchema('page', 'pageSchema', 'basicInfo', 'new')"
      :model="formModel"
      :options="formOptions"
      class="vue-form-generator--admin">
    </vue-form-generator>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import newForm from '@/mixins/new-form';

  export default {
    name: 'admin-new-page',
    mixins: [newForm],

    data() {
      return {
        formName: 'Page',
        formParent: 'Survey',
        formIndex: 'admin-design-survey',
      };
    },

    computed: {
      ...mapGetters('admin', [
        'activeSurvey',
      ]),
    },
  };
</script>
